import { render, staticRenderFns } from "./loginLog.vue?vue&type=template&id=c66c3616&scoped=true"
import script from "./loginLog.vue?vue&type=script&lang=js"
export * from "./loginLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66c3616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/dev-node-01/workspace/test-flight/tinggo/tinggo-vue-12765/server_app_code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c66c3616')) {
      api.createRecord('c66c3616', component.options)
    } else {
      api.reload('c66c3616', component.options)
    }
    module.hot.accept("./loginLog.vue?vue&type=template&id=c66c3616&scoped=true", function () {
      api.rerender('c66c3616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/risk/loginLog.vue"
export default component.exports